var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleTransitPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 597,
    height: 279,
    viewBox: "0 0 597 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M506.67 91.8289L510.372 46.582L520.97 47.3096L524.36 88.752L506.67 91.8289Z",
    fill: "#006D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M511.617 55.724L513.436 7.25586H517.228L519.41 55.1007L511.617 55.724Z",
    fill: "#006D8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M515.513 8.51356C517.864 8.51356 519.769 6.60774 519.769 4.25678C519.769 1.90583 517.864 0 515.513 0C513.162 0 511.256 1.90583 511.256 4.25678C511.256 6.60774 513.162 8.51356 515.513 8.51356Z",
    fill: "#006D8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M525.715 44.6431L527.008 38.4766H503.135L504.509 45.4645L503.217 45.5142L503.643 48.3617L526.493 47.9342L527.098 44.5886L525.715 44.6431ZM524.853 44.6768L519.087 44.9006L519.868 39.314H525.977L524.853 44.6768ZM510.791 45.2223L510.191 39.314H519.024L518.238 44.9335L510.791 45.2223ZM504.152 39.314H509.35L509.954 45.2544L505.355 45.4324L504.152 39.314Z",
    fill: "#006D8D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M522.405 24.7329L523.294 20.4922H506.875L507.82 25.2984L506.931 25.3329L507.225 27.2908L522.94 26.9973L523.356 24.696L522.405 24.7329ZM521.812 24.7562L517.846 24.9102L518.384 21.0681H522.585L521.812 24.7562ZM512.141 25.1308L511.728 21.0673H517.803L517.262 24.9327L512.141 25.1308ZM507.574 21.0673H511.149L511.565 25.1532L508.401 25.2759L507.574 21.0673Z",
    fill: "#006D8D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M357.257 82.1536L353.992 129.119L386.666 122.204L386.129 72.582L357.257 82.1536Z",
    fill: "#EF701B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M386.129 72.582L461.348 82.934L453.169 125.666L386.471 122.204L386.129 72.582Z",
    fill: "#FDA635"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.006 68.1999L147.541 70.2669L156.103 67.7868V65.3652L147.006 68.1999Z",
    fill: "#92B4EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.541 70.2672L163.294 73.1604L168.503 71.0348L156.103 67.7871L147.541 70.2672Z",
    fill: "#583D71"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M156.102 65.3652L169.604 68.9482L168.502 71.0345L156.102 67.7868V65.3652Z",
    fill: "#006D8D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.025 69.4395L157.377 78.8626L162.808 79.6904L163.153 71.2867L157.025 69.4395Z",
    fill: "#006D8D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.024 69.4395L151.555 71.0044L151.987 77.4509L157.376 78.8626L157.024 69.4395Z",
    fill: "#92B4EA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.07 82.1295L151.849 75.3027L152.345 90.0743L129.048 89.0869L127.07 82.1295Z",
    fill: "#92B4EA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.847 75.3027L175.635 80.8004L175.235 93.1167L151.164 89.8088L151.847 75.3027Z",
    fill: "#006D8D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114.691 98.6275L117.057 69.7949H122.72L125.793 98.6275H114.691Z",
    fill: "#92B4EA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.742 79.8665L118.641 32.1523H120.313L121.211 78.6248L117.742 79.8665Z",
    fill: "#92B4EA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.915 96.9399L119.313 37.4869L103.495 90.815L103.01 90.6714L119.3 35.752L138.398 96.7891L137.915 96.9399Z",
    fill: "#92B4EA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6094 96.2242L69.6571 87.3441L103.01 70.625L101.912 85.3701L67.6094 96.2242Z",
    fill: "#006D8D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.009 70.625L183.36 86.3936L180.245 104.063L101.912 85.3701L103.009 70.625Z",
    fill: "#583D71"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8027 90.9715L78.7284 104.455L100.988 105.745L97.6966 83.5352L77.8027 90.9715Z",
    fill: "#92B4EA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0665 102.986L90.2227 235.141L198.047 228.899L180.058 122.068L91.0665 102.986Z",
    fill: "#006D8D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0661 102.986L90.2223 235.141L34.5176 236.788L55.479 117.864L91.0661 102.986Z",
    fill: "#92B4EA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1195 83.1016L50.8574 122.437L202.47 137.389L198.049 111.085L64.1195 83.1016Z",
    fill: "#006D8D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M198.049 110.382L64.1198 83.1016L60.1133 92.2696L61.2162 91.8654L198.764 115.337L198.049 110.382Z",
    fill: "#583D71"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1183 83.1016L11.0509 106.444L4.41992 137.389L50.8563 122.437L64.1183 83.1016Z",
    fill: "#92B4EA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41992 137.39L50.8563 139.753L91.0667 126.103L50.8563 122.438L4.41992 137.39Z",
    fill: "#583D71"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6953 83.5351L100.126 119.485L110.819 79.0586L97.6953 83.5351Z",
    fill: "#92B4EA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M100.127 119.485L180.031 129.068L187.979 96.4627L110.82 79.0586L100.127 119.485Z",
    fill: "#006D8D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M135.875 92.1296L129.998 115.772L112.078 113.211L117.056 87.6113L135.875 92.1296ZM162.722 98.5737L158.3 121.318L176.219 123.879L181.395 103.057L162.722 98.5737ZM141.027 93.3664L136.255 117.905L154.175 120.466L159.792 97.8711L141.027 93.3664Z",
    fill: "#CBE3F8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M159.793 97.8703L149.901 95.4961L139.425 101.607L137.395 112.051L159.631 98.52L159.793 97.8703Z",
    fill: "#E1F1FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M159.02 100.971L136.987 114.136L136.254 117.905L141.447 118.646L157.077 108.788L159.02 100.971Z",
    fill: "#E1F1FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M129.998 115.771L132.517 105.635L118.062 114.066L129.998 115.771Z",
    fill: "#E1F1FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M155.237 116.199L156.303 111.908L145.213 119.184L149.738 119.831L155.237 116.199Z",
    fill: "#E1F1FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M172.905 101.018L160.69 109.031L159.895 113.123L176.805 101.954L172.905 101.018Z",
    fill: "#E1F1FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M161.248 106.158L170.364 100.408L162.944 98.627L162.681 98.7834L161.248 106.158Z",
    fill: "#E1F1FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M112.871 130.793L113.313 142.066L105.135 141.476L106.461 129.178L112.871 130.793ZM141.25 132.267L140.84 142.766H147.642L147.2 133.593L141.25 132.267ZM168.53 133.703V144.203H174.056L173.061 134.63L168.53 133.703Z",
    fill: "#583D71"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0496 106.444L10.1504 110.585L61.2133 91.8654L64.1169 83.1016L11.0496 106.444Z",
    fill: "#8C71A9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5332 205.193L12.1234 234.788H37.6224L38.2801 196.6L8.5332 205.193Z",
    fill: "#EF701B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2805 196.6L93.3363 201.24V234.005L37.4688 234.788L38.2805 196.6Z",
    fill: "#FDA635"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2344 195.873V227.708L66.9259 222.011L67.5066 188.283L41.2344 195.873Z",
    fill: "#A1C5EB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5053 188.283L119.959 195.502L114.255 225.3L66.7891 222.011L67.5053 188.283Z",
    fill: "#CBE3F8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2038 151.632L83.6699 188.092L109.035 182.724L108.805 144.201L86.2038 151.632Z",
    fill: "#A1C5EB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M108.805 144.201L167.013 152.237L160.663 185.411L108.883 182.724L108.805 144.201Z",
    fill: "#CBE3F8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M76.254 188.168L72.6445 218.827L105.64 218.064L106.305 179.486L76.254 188.168Z",
    fill: "#B72727"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M106.305 179.486L161.922 184.174V217.274L105.484 218.064L106.305 179.486Z",
    fill: "#F3A178"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M126.24 181.941L129.83 211.536H155.329L155.987 173.348L126.24 181.941Z",
    fill: "#EF701B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M155.988 173.348L211.043 177.988V210.753L155.176 211.536L155.988 173.348Z",
    fill: "#FDA635"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M126.697 146.782L130.954 181.866L155.01 175.587L155.835 138.418L126.697 146.782Z",
    fill: "#B72727"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M155.835 138.418L211.865 144.552L207.169 179.212L154.859 175.587L155.835 138.418Z",
    fill: "#F3A178"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M179.665 134.147L175.227 174.576L207.306 167.788L206.852 125.809L179.665 134.147Z",
    fill: "#A1C5EB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M206.854 125.809L270.486 134.566L263.566 170.716L207.142 167.788L206.854 125.809Z",
    fill: "#CBE3F8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M272.648 71.3474L267.609 114.285L304.027 107.076L303.512 62.4922L272.648 71.3474Z",
    fill: "#A1C5EB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M303.514 62.4922L378.858 72.1921L375.754 114.285L303.843 107.076L303.514 62.4922Z",
    fill: "#CBE3F8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M171.59 173.72L167.656 207.13L203.612 206.298L204.336 164.26L171.59 173.72Z",
    fill: "#B72727"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M204.336 164.26L264.943 169.368V205.437L203.443 206.298L204.336 164.26Z",
    fill: "#F3A178"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M221.943 122.534L218.744 168.552L250.758 161.777L250.232 113.156L221.943 122.534Z",
    fill: "#EF701B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M250.232 113.156L323.933 123.3L315.919 165.168L250.567 161.777L250.232 113.156Z",
    fill: "#FDA635"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M217.268 166.423L212.713 205.119L254.357 204.156L255.195 155.467L217.268 166.423Z",
    fill: "#A1C5EB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M255.195 155.467L325.391 161.382V203.158L254.16 204.156L255.195 155.467Z",
    fill: "#CBE3F8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M264.943 112.937L265.656 159.96L300.551 150.852L301.627 102.408L264.943 112.937Z",
    fill: "#B72727"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M301.626 102.408L374.655 110.404L368.534 155.577L300.355 150.852L301.626 102.408Z",
    fill: "#F3A178"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M390.793 135.423L449.147 72.582H560.107L590.168 132.23L390.793 135.423Z",
    fill: "#006D8D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 221.383L12.2843 270.895H513.882L596.799 136.284C583.14 111.529 589.071 88.42 566.344 79.0586C481.39 84.9621 369.928 107.703 278.438 136.505L239.232 171.75C232.1 178.161 222.871 182.539 212.78 184.297L0 221.383Z",
    fill: "#F37435"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M296.98 141.609C296.98 141.609 299.301 153.897 294.249 155.466C289.198 157.036 290.426 143.111 290.426 143.111L296.98 141.609ZM184.503 194.664C184.503 194.664 183.275 208.59 188.326 207.019C193.378 205.45 191.057 193.162 191.057 193.162L184.503 194.664ZM94.203 210.365C94.203 210.365 93.1322 222.502 97.535 221.134C101.938 219.766 99.9148 209.056 99.9148 209.056L94.203 210.365ZM24.2698 223.327C24.2698 223.327 23.4837 232.234 26.7146 231.23C29.9455 230.226 28.4608 222.367 28.4608 222.367L24.2698 223.327ZM376.364 119.75C376.364 119.75 375.135 133.676 380.187 132.106C385.239 130.536 382.917 118.248 382.917 118.248L376.364 119.75ZM472.629 100.625C472.629 100.625 471.4 114.552 476.452 112.981C481.504 111.411 479.182 99.123 479.182 99.123L472.629 100.625Z",
    fill: "#241933"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M566.344 79.0586L513.881 270.895L596.798 136.284C596.799 111.225 589.07 88.42 566.344 79.0586Z",
    fill: "#241933"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2843 270.895L8.53125 278.999H519.513L513.882 270.895H12.2843Z",
    fill: "#F37435"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M551.658 133.661C542.045 127.835 493.026 140.441 418.824 159.522C315.964 185.972 163.027 225.299 5.46484 243.408L5.88514 245.102C163.487 226.969 316.398 187.649 419.256 161.198C490.382 142.909 541.773 129.694 550.761 135.142C564.686 143.583 574.377 153.022 581.101 161.769L582.067 160.201C575.241 151.441 565.508 142.058 551.658 133.661Z",
    fill: "#241933"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M364.551 213.399C328.347 229.244 293.195 248.718 254.521 256.855C186.286 271.214 115.462 248.752 45.9863 254.699C33.8264 255.74 21.4507 257.787 10.0977 262.085L12.2834 270.895H513.881L542.471 224.48C525.249 207.746 503.027 196.128 479.367 191.925C440.456 185.013 400.756 197.553 364.551 213.399Z",
    fill: "#241933"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleTransitPolicy);
export default __webpack_public_path__ + "static/media/SingleTransitPolicy.f6a0c9f59b278a8f23af30d678a0dc28.svg";
export { ForwardRef as ReactComponent };